import { createSlice } from '@reduxjs/toolkit'
import { ActionPanelItem } from 'helpers/action-panel-item'

const initialState = {
    actions: Array<ActionPanelItem>(),
    actionsVisible: false,
}

const actionPanelSlice = createSlice({
    name: 'actionPanel',
    initialState,
    reducers: {
        clearActions: (state) => {
            state.actions = []
        },
        addActions: (state, action) => {
            state.actions = [...state.actions, ...action.payload]
            state.actions.sort((a, b) => a.id - b.id)
        },
        updateAction: (state, action) => {
            state.actions = state.actions.map((item: any) => {
                return item.id === action.payload.id
                    ? action.payload
                    : item
            })
        },
        setActions: (state, action) => {
            state.actions = action.payload
            state.actions.sort((a, b) => a.id - b.id)

            state.actionsVisible = action.payload.length !== 0
        }
    }
})

export const { clearActions, addActions, updateAction, setActions } = actionPanelSlice.actions
export default actionPanelSlice.reducer
